import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import ErrorModal from "../Security/ErrorModal";
import { Endpoints } from "../../Global/Endpoints";
import { useTranslation } from 'react-i18next';
import ChatBotWindow from "../ChatBot/ChatBotWindow";
import { useChat } from '../Layout/ChatContext';
const ChildDevelopment = () => {
    const [loading, setLoading] = useState(false);
    const {isChatVisible, toggleChat, showChat } = useChat();
    const [error, setError] = useState(null);
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const userInfo = useSelector((state) => state.userData.userData);
    const token = localStorage.getItem("AccessToken");
    const [showModal, setShowModal] = useState(false); // State to control modal visibility
    const [modalMessage, setModalMessage] = useState(""); // State for modal message
    const deviceType = "PatientPortal";

    const ssoData = useSelector((state) => state.sso.ssoUserData);
    const isHighmarkPortal = ssoData?.Portal === "Highmark";

    const sections = [
        { title: t("articles"), path: "articles" },
        { title: t("activities"), path: "activities" },
        { title: t("assessments"), path: "interviews" },
        { title: t("previousassessmentsresults"), path: "transcripts" }
    ];

    const handleClick = async (path) => {
        if (!userInfo.EmailID || !token) {
           // alert("Missing email or access token.");
            return;
        }

        setLoading(true); // Show loading state while fetching
        const params = {
            EmailID: userInfo.EmailID,
            Topic: path, // Pass the selected topic as a parameter
            DeviceType:deviceType
        };

        try {
            const response = await axios.post(
                Endpoints.VitalExchange,
                `_Params=${encodeURIComponent(JSON.stringify(params))}`,
                {
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        Authorization: `Bearer ${token}`,
                    }
                }
            );
            const baseTopicLink = response.data.TopicLink;
            if (baseTopicLink) {
                
                const servicemodule="Education";
                const childdevelopment="Child Development"
                 const formattedActivity = `${servicemodule}:${childdevelopment}:${baseTopicLink}`;
               //  console.log(formattedActivity)
                 if (userInfo.EmailID && token) {
                   try {
                     const payload = `_Params=${encodeURIComponent(
                       JSON.stringify({ EmailID: userInfo.EmailID, Activity: formattedActivity, DeviceType: deviceType })
                     )}`;
                     axios.post(Endpoints.CallRecoderLog, payload, {
                       headers: {
                         "Content-Type": "application/x-www-form-urlencoded",
                         Authorization: `Bearer ${token}`,
                       },
                     });
             
                    //  console.log(formattedActivity +"activity logged successfully.");
                   } catch (error) {
                   }
                 }
                

                navigate(`/child-development/${path}`, { state: { baseTopicLink } });
            } else {
                setModalMessage(response.data.Message)
                setShowModal(true);
            }
        } catch (err) {
            setError("Error fetching data. Please try again.");
        } finally {
            setLoading(false); // Hide loading state after the request completes
        }
    };

    const handleBack = () => {
        navigate(-1);
    };
    const handleOkClick = () => {
        setShowModal(false); // Close the modal when the OK button is clicked
      };
    return (
        <>

{isHighmarkPortal ? 
          <div className="col-md-12 mt-4 d-flex inner-page-heading-wrapper">
          <button className="win-back-btn" onClick={handleBack}>
              <span>
              <i className="bi bi-chevron-left"></i>
              </span>
          </button>       
          <h2 className="page-heading">{t('ChildDevelopmenttitle')}</h2>
          </div>:
          <div className="col-md-12 mt-4 d-flex inner-page-heading-wrapper">
          <button className="win-back-btn" onClick={handleBack}>
              <span>
              <i className="bi bi-chevron-left"></i>    
              {t('Back')}        
              </span>
          </button>       
          <h2 className="page-heading">{t('ChildDevelopmenttitle')}</h2>
          </div>
      }
            {/* <div className="col-md-12 col-lg-12 mt-4 inner-page-heading-wrapper">
                <button className="win-back-btn" onClick={handleBack}>
                    <span>
                        <i className="bi bi-chevron-left"></i> {t("Back")}
                    </span>
                </button>
                <h2 className="page-heading">{t("ChildDevelopmenttitle")}</h2>
            </div> */}

            {loading ? (
                <p>{t("Loading")}</p>
            ) : error ? (
                <div style={{ color: "red" }}>{error}</div>
            ) : (
                <div className="favorites-wrapper">
                    <div className="find-provider-wrapper">
                    {sections.map((section, index) => (
                        <div
                            key={index}
                            className="schedule-block"
                            onClick={() => handleClick(section.path)}
                        >
                            <span class="schedule-block-left-logo"></span>
                            <div className="service-content find-provider">
                                <h4>{section.title}</h4>
                            </div>
                        </div>
                    ))}
                    </div>
                    <ErrorModal
        show={showModal}
        message={modalMessage}
        onClose={() => setShowModal(false)}
        onOkay={handleOkClick}
      />
                </div>
            )}
            {/* {isChatVisible && <ChatBotWindow />} */}
        </>
    );
};

export default ChildDevelopment;
